import { IDataTableColumn } from 'react-data-table-component';

import { Button, Typography } from '@mui/material';

import Delete from '@mui/icons-material/Delete';

import StatusCell from '../../../sharedModules/layout/StatusCell';

import { BackflowJobGroup } from '../../model';

const parseDate = (dateStr: string | undefined): number => {
  if (!dateStr) return 0;
  const [datePart, timePart] = dateStr.split(' ');
  const [month, day, year] = (datePart || '').split('/');
  if (!month || !day || !year) return 0;
  const [hours, minutes] = (timePart || '00:00').split(':');
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hours), parseInt(minutes)).getTime();
};

const dateSortFunction = (field: string) => (a: BackflowJobGroup, b: BackflowJobGroup) => {
  return parseDate(a[field]) - parseDate(b[field]);
};

export const backflowJobGroupsColumns = (
  handleDelete?: (item: BackflowJobGroup) => void,
  includeWaterAuthority: boolean = false,
  dateColumn: 'scheduled' | 'submitted' = 'scheduled',
): IDataTableColumn<BackflowJobGroup>[] => {
  const dateColumnConfig: IDataTableColumn<BackflowJobGroup> =
    dateColumn === 'submitted'
      ? { name: 'Submitted', selector: 'submitted_at', sortable: true, sortFunction: dateSortFunction('submitted_at') }
      : {
          name: 'Scheduled',
          selector: 'schedule_dates',
          sortable: true,
          sortFunction: dateSortFunction('schedule_dates'),
        };

  const baseColumns: IDataTableColumn<BackflowJobGroup>[] = [
    dateColumnConfig,
    {
      name: 'Order',
      selector: 'order_no',
      sortable: true,
    },
    {
      name: 'Customer',
      selector: 'company_name',
      sortable: true,
    },
    {
      name: 'Address',
      selector: 'address',
      grow: 2,
      sortable: true,
    },
    {
      name: 'Water Authority Info',
      selector: 'authority_provided_values_complete',
      sortable: true,
      omit: !includeWaterAuthority,
      cell: (row) => <StatusCell status={row.authority_provided_values_complete} />,
    },
    {
      name: 'Asset Count',
      selector: 'asset_count',
      sortable: true,
    },
    {
      name: 'Status',
      selector: 'status',
      sortable: true,
      omit: includeWaterAuthority,
      cell: (row) => <StatusCell status={row.status} />,
    },
    {
      name: 'Actions',
      selector: 'actions',
      grow: 0.5,
      cell: (row) => (
        <Button variant="contained" color="warning" onClick={() => handleDelete(row)} disabled={!row.allow_delete}>
          <Delete />
        </Button>
      ),
    },
  ];

  return baseColumns;
};
